module.exports = __webpack_public_path__ + "img/dropoff-controller.31727179.svg";